module.exports = __webpack_public_path__ + "img/icon-remove-role.602fa14f.svg";